import {type UpdateNeededReason} from '@rocicorp/zero'

export async function handleUpdateNeeded(reason: UpdateNeededReason) {
  console.warn('[Zero] Update needed:', reason.type, reason.message ?? '')

  if (window.__isForceReloading) return
  window.__isForceReloading = true

  try {
    await fetch('/clear-cache', {cache: 'no-store'})
  } catch (e) {
    console.warn('[Zero] Failed to call /clear-cache:', e)
  }

  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map(r => r.unregister()))
    } catch (e) {
      console.warn('[Zero] Failed to unregister service workers:', e)
    }
  }

  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map(name => caches.delete(name)))
    } catch (e) {
      console.warn('[Zero] Failed to clear caches:', e)
    }
  }

  window.location.reload()
}
